<template>
  <footer class="py-16 text-white bg-gray-900">
    <div class="max-w-[1440px] mx-auto px-4 md:px-8">
      <div class="grid grid-cols-1 gap-8 mb-12 md:grid-cols-2 lg:grid-cols-4">
        <div data-aos="fade-up" data-aos-delay="100">
          <a href="#" class="flex items-center gap-2 text-2xl md:text-3xl font-['Pacifico'] text-primary mb-6">
            <img class="w-10 h-10 md:w-12 md:h-12" src="logo.png" alt="GREA Logo">
            <span>Global Real Estate Advisors(GREA)</span>
          </a>
          <p class="mb-6 text-gray-400">{{ $t('components.TheFooter.548973-0') }}</p>
          <div class="flex space-x-4">
            <a href="#" class="text-gray-400 transition-colors hover:text-primary"><i class="fab fa-facebook-f"></i></a>
            <a href="#" class="text-gray-400 transition-colors hover:text-primary"><i class="fab fa-twitter"></i></a>
            <a href="#" class="text-gray-400 transition-colors hover:text-primary"><i class="fab fa-instagram"></i></a>
            <a href="#" class="text-gray-400 transition-colors hover:text-primary"><i class="fab fa-linkedin-in"></i></a>
          </div>
        </div>

        <div data-aos="fade-up" data-aos-delay="200">
          <h4 class="mb-6 text-lg font-semibold">{{ $t('components.TheFooter.548973-1') }}</h4>
          <ul class="space-y-4">
            <li><a href="index.html" class="text-gray-400 transition-colors hover:text-primary">{{
              $t('components.TheFooter.548973-2') }}</a></li>
            <li><a href="about.html" class="text-gray-400 transition-colors hover:text-primary">{{
              $t('components.TheFooter.548973-3') }}</a></li>
            <li><a href="properties.html" class="text-gray-400 transition-colors hover:text-primary">{{
              $t('components.TheFooter.548973-4') }}</a></li>
            <li><a href="investment.html" class="text-gray-400 transition-colors hover:text-primary">{{
              $t('components.TheFooter.548973-5') }}</a></li>
            <li><a href="contact.html" class="text-gray-400 transition-colors hover:text-primary">{{
              $t('components.TheFooter.548973-6') }}</a></li>
          </ul>
        </div>

        <div data-aos="fade-up" data-aos-delay="300">
          <!-- <h4 class="mb-6 text-lg font-semibold">{{ $t('components.TheFooter.548973-7') }}</h4>
          <ul class="space-y-4">
            <li><a href="https://www.zillow.com" target="_blank"
                class="text-gray-400 transition-colors hover:text-primary">Zillow</a></li>
            <li><a href="https://www.realtor.com" target="_blank"
                class="text-gray-400 transition-colors hover:text-primary">Realtor.com</a></li>
            <li><a href="https://www.redfin.com" target="_blank"
                class="text-gray-400 transition-colors hover:text-primary">Redfin</a></li>
            <li><a href="https://www.trulia.com" target="_blank"
                class="text-gray-400 transition-colors hover:text-primary">Trulia</a></li>
            <li><a href="https://www.rightmove.co.uk" target="_blank"
                class="text-gray-400 transition-colors hover:text-primary">Rightmove</a></li>
          </ul> -->
        </div>

        <div data-aos="fade-up" data-aos-delay="400">
          <h4 class="mb-6 text-lg font-semibold">{{ $t('views.Contact.559433-1') }}</h4>
          <p class="mb-6 text-gray-400">{{ $t('views.Contact.559433-2') }}</p>
          <button @click="contactUs"
            class="w-full bg-primary text-white py-2 !rounded-button hover:bg-opacity-90 transition-all whitespace-nowrap">
            {{ $t('views.Contact.559433-4') }}
          </button>
        </div>
      </div>

      <div class="pt-8 text-center border-t border-gray-800">
        <p class="text-gray-400" data-aos="fade-up" data-aos-delay="100">{{ $t('components.TheFooter.548973-17') }}</p>
      </div>
    </div>
  </footer>
</template>

<script>
import Swal from 'sweetalert2'
import contactMixin from '@/mixins/contactMixin'
export default {
  name: 'TheFooter',
  mixins: [contactMixin],
  data() {
    return {
      em: '',
    };
  },
  methods: {
    submitemaik() {
      if (this.em) {
        Swal.fire({
          icon: 'success',
          title: 'OK',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
          background: '#f0fdf4',
          color: '#16a34a',
          customClass: {
            popup: 'rounded-lg shadow-lg'
          }
        });
        return;
      }else{
       
        Swal.fire({
          icon: 'warning',
          title: this.$t('views.Home.884896-77'),
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
          background: '#fff5f5',
          color: '#d62828',
          customClass: {
            popup: 'rounded-lg shadow-lg'
          }
        });
        return;
      
      }
    }
  }
}
</script>